import React from 'react';
import { connect } from 'react-redux';
import '@/assets/styles/components/ipo/allotment-enquire.scss';
import { IPOActions } from '@/actions/trading';
import { Converter } from '../../../helpers/functions';
import { PARAMS } from '@/constants/params';
import Tips from '../../Tips/Tips';
import { SERVICES_RESP as servicesResp,Icons } from '@/configurations';
import { REFRESH_DATA, LOADING_TYPE} from '@/constants/app';
import LoadingLayer from '../../../../../components/Spinner/LoadingLayer';
class AllotmentResultEnquiry extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allotment: [],
      totalAmt: '',
      showButton:false,
      showTips:false,
      isSuccess:false,
      message:''
    }
  }

  componentDidMount() {
    this.getAllotmentResult();
  }

  getAllotmentResult() {
    const { currentTradingAccount, language, data, useIpoAppliedDetailsEnquiryAPI} = this.props;
    const { clientID, tradingAccSeq } = currentTradingAccount
    let params = {
      [PARAMS.CLIENT_ID]: clientID,
      [PARAMS.TRADING_ACCOUNT_ID]: clientID,
      [PARAMS.TRADING_ACC_SEQ]: tradingAccSeq,
      [PARAMS.ENTITLEMENT_ID]: data[PARAMS.ENTITLEMENT_ID],
      [PARAMS.MARKET_ID]: data[PARAMS.MARKET_ID],
      [PARAMS.INSTRUMENT_ID]: data[PARAMS.INSTRUMENT_ID],
      [PARAMS.LANGUAGE]: language.lang,
      [PARAMS.SUBSCRIPTION_ID] : data[PARAMS.SUBSCRIPTION_ID]
    }
    if(useIpoAppliedDetailsEnquiryAPI){
      this.props.ipoAppliedDetailsEnquiry(params,res =>{
        let result = JSON.parse(JSON.stringify( res ));
        result[PARAMS.MARKET_ID] = data[PARAMS.MARKET_ID];
        result[PARAMS.INSTRUMENTNAME] = data[PARAMS.INSTRUMENTSHORTNAME];
        result[PARAMS.INSTRUMENT_CHINESE_NAME] = data[PARAMS.INSTRUMENT_CHINESE_SHORT_NAME];
        result[PARAMS.MINOFFERPRICE] = data[PARAMS.MINOFFERPRICE];
        result[PARAMS.MAXOFFERPRICE] = data[PARAMS.MAXOFFERPRICE];
        result[PARAMS.CURRENCY_ID] = data[PARAMS.CURRENCY_ID];
        this.generateAllotmentData(result)
      })
    }else{
      this.props.allotmentResultEnquire(params, res => {
        this.generateAllotmentData(res)
      })
    }
  }

  generateAllotmentData(allotmentResp) {
    const {ipoCancel,useIpoAppliedDetailsEnquiryAPI } = this.props;
    allotmentResp.listingDate = this.props.data.listingDate
    this.setState({
      allotment: Converter.mapAllotmentData(allotmentResp,useIpoAppliedDetailsEnquiryAPI).allotment,
      totalAmt: Converter.mapAllotmentData(allotmentResp,useIpoAppliedDetailsEnquiryAPI).totalAmt,
      showButton:ipoCancel
    });
  }

  IpoCancelSubmit = () => {
    const {language,user,currentTradingAccount,data} = this.props;
    const {allotment} = this.state;
    const { clientID, tradingAccSeq } = currentTradingAccount;
    let subscriptionID = '';
    for(let allot of allotment){
      if(allot.label === 'common_reference_no'){
        subscriptionID = allot.value;
        break;
      }
    }
    this.setState({
      isLoading:true
    })
    const params = {
      [PARAMS.CLIENT_ID]:clientID,
      [PARAMS.TRADING_ACCOUNT_ID]:clientID,
      [PARAMS.TRADING_ACC_SEQ]:String(tradingAccSeq),
      [PARAMS.ENTITLEMENT_ID]:data.entitlementID,
      [PARAMS.SUBSCRIPTION_ID]:subscriptionID,
    }
    this.props.ipoCancelAction(params ,res =>{
      if(res.result.errorCode === servicesResp.SUCCESS_CODE){
        this.setState({
          showTips:true,
          isSuccess:true,
          message:language.ipo_cancel_success_message,
          showButton:false,
          isLoading:false
        })
      }else{
        this.setState({
          showTips:true,
          isSuccess:false,
          message:language.ipo_cancel_failed_message,
          showButton:false,
          isLoading:false
        })
      }
      this.props.toggleRefreshTable(true);
    })
  }

  render() {
    const { language } = this.props;
    const { allotment, totalAmt, showTips, isSuccess,message,showButton,isLoading } = this.state;

    return (
      <React.Fragment>
        <div className="allotment-container">
          {showTips && <div style={{padding:'5px'}}>
            <Tips isSuccess={isSuccess} isNoBgColor style={{ margin: '0 0 16px -17px', fontSize: '20px' }}>{message}</Tips>
          </div>}
          <div className='allotment-head'>
            {allotment.map(allot => {
              if(allot.label && allot.label === 'ipo_event_status' || allot.label === 'common_reference_no'){
                return (
                  <div className="allotment-status" key={allot.label + '-' + allot.value}>
                    <div>{language[allot.label] + ':'}&nbsp;&nbsp;</div>
                    <div style={{color: allot.label === 'ipo_event_status' ? '#1996e3' : ''}}>{allot.value}</div>
                  </div>
                )
              }
            })}
          </div>
          <div className="allotment-inner">
            {allotment.map(allot => {
              if(allot.label && allot.label !== 'ipo_event_status' && allot.label !== 'common_reference_no'){
                return (
                  <div className="allotment-row" key={allot.label + '-' + allot.value}>
                    <div className="allotment-label">{language[allot.label]}</div>
                    <div className="allotment-value">{allot.value}</div>
                  </div>
                )
              }
            })}
          </div>
          <div className="allotment-amount">
            <label>{language.common_total_amount}: </label>
            <h4>{totalAmt}</h4>
          </div>
          {showButton  && <div className="allotment-button">
            <button className="clear" onClick={() => {this.props.onClose()}}>{language.common_cancel}</button>
            <button className="confirm" onClick={() => this.IpoCancelSubmit()}>{language.common_confirm}</button>
          </div>}
        </div>
      </React.Fragment>
    )
  }


}

export default connect(
  state => ({
    language: state.app.language,
    currentTradingAccount: state.trade.currentTradingAccount,
    user: state.auth.user
  }),
  dispatch => ({
    allotmentResultEnquire: (p, res) => dispatch(IPOActions.allotmentResultEnquireAction(p, res)),
    ipoCancelAction:(p,res) => dispatch(IPOActions.ipoCancelAction(p,res)),
    toggleRefreshTable: (p) => dispatch({
      type: REFRESH_DATA.IPO_ACTION,
      value: p
    }),
    ipoAppliedDetailsEnquiry: (p, res) => dispatch(IPOActions.ipoAppliedDetailsEnquiryAction(p, res))
  })
)(AllotmentResultEnquiry)